import { AxiosResponse } from 'axios';

import { Scheduler } from './../pages/inventory-control/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessGetFilterScheduler extends ResponseREST {
	data: Array<Scheduler>;
}

export const getFilterScheduler = async (
	outletId: Array<number>,
	day: Array<string>,
	status: string,
): Promise<ResponseSuccessGetFilterScheduler> => {
	return axiosInstance
		.get('filter-scheduler', {
			params: {
				outletId,
				day,
				status,
			},
		})
		.then((res: AxiosResponse<ResponseSuccessGetFilterScheduler>) => res.data)
		.catch((err) => err);
};
